import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Project",
  "Handover Date",
  "Site Manager",
  "Actions",
];
const ProjectHandoverTable = ({ PH = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const goToView = (id) => {
    navigate(`/client-project-handover/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PH?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.clientName || "N/A"}</td>
                <td>{item?.handOverDate || "N/A"}</td>
                <td>{item?.siteManagerName}</td>
                <td>
                  <CustomViewButton  onClick={() => goToView(item.id)}></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectHandoverTable;
